import React, { ComponentProps } from "react";

type FinderType = {} & ComponentProps<"div">;

export const WrapperFinder: React.FC<FinderType> = (props) => {
  return (
    <div {...props} className={`rounded-2xl border border-[#E6E8EC] bg-white ${props.className}`}>
      {props.children}
    </div>
  );
};
